<template>
  <div class="content-container">
    <div class="test-bg" v-if="!showTableList.length">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <el-table
    :data="showTableList"
    style="width: 100%"
    class="warning-row"
     v-else
    >
    <el-table-column
      prop="evaluate_name"
      label="名称"
    >
      <template slot-scope="scope">
        <div style="color: #1989FA;">
          {{scope.row.evaluate_name}}
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="test_name"
      label="测试内容"
      >
    </el-table-column>
     <el-table-column
      label=" 掌握程度"
      prop="avg_ability"
      align="center"
      width="100"
      sortable
      >
       <template slot-scope="scope">
          <div
          v-if="scope.row.avg_ability*100>=40&&scope.row.avg_ability*100<70" style="color:#F99830">
            {{Math.round(scope.row.avg_ability*100)}}%
          </div>
          <div v-else-if="scope.row.avg_ability*100>=70" style="color:#67C23A">
          {{Math.round(scope.row.avg_ability*100)}}%
          </div>
          <div v-else style="color:#F56C6C">
          {{Math.round(scope.row.avg_ability*100)}}%
          </div>
        </template>
    </el-table-column>
     <el-table-column
      prop="created"
      label="老师发布时间"
      width="200"
      align="center"
      sortable>
    </el-table-column>
     <el-table-column
      prop="end_time"
      label="测试完成时间"
      width="200"
      align="center"
      sortable>
    </el-table-column>
    <el-table-column
      label="操作"
      align="center"
      width="90"
      >
       <template slot-scope="scope">
          <a @click="goReport(scope.row.tsid)" class="go-report">查看报告</a>
        </template>
    </el-table-column>
   </el-table>
  </div>
</template>

<script>
import { openTab } from '@/utils';

export default {
  name: 'FinishedContent',
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    finishedList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goReport(id) {
      const schoolId = localStorage.getItem('school_id') || '';
      const url = `${window.location.protocol}//${window.location.host}/dl-web/question/report?id=${id}&schoolId=${schoolId}`;
      openTab(url);
    },
  },
  computed: {
    showTableList() {
      if (this.activeId === '0') {
        return this.finishedList;
      }
      return this.finishedList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-container{
    display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .go-report{
  font-weight: 500;
  color: #1989FA;
  cursor: pointer;
}
.test-bg{
    margin: 86px auto;
    position: relative;
    img{
      display: block;
    }
    span{
      position: absolute;
      left: 50%;
      transform: translate(-50%,12px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.6);
    }
}
}

::v-deep {
  .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
}
</style>
